import React, { Component } from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import MediaQuery from 'react-responsive'
import { Layout, Button } from 'antd'

import { LogoSmall, Cinnova } from './utils/Utils'
import Notifications from './utils/Notifications'
import Menu from './utils/Menu'
import Home from './boards/Home'

import './App.less'

import GeneralValledetenza from './boards/valleDeTenza/General'
import PressureValledetenza from './boards/valleDeTenza/Pressure'
import TemperatureValledetenza from './boards/valleDeTenza/Temperature'
import FlowValledetenza from './boards/valleDeTenza/Flow'

import GeneralMochilleros from './boards/mochileros/General'
import PressureMochileros from './boards/mochileros/Pressure'
import TemperatureMochileros from './boards/mochileros/Temperature'
import FlowMochileros from './boards/mochileros/Flow'

import GeneralPaez from './boards/paez/General'
import PressurePaez from './boards/paez/Pressure'
import VolumenPaez from './boards/paez/Volumen'

import PressureUmbita from './boards/umbita/Pressure'
import VolumenUmbita from './boards/umbita/Volumen'
import TemperatureUmbita from './boards/umbita/Temperature'

const { Header, Content } = Layout

export default class App extends Component {
  constructor (props) {
    super(props)
    this.state = { isOpenMenu: window.innerWidth >= 1280 }
  }

  onToggleMenu (state) {
    state = state || { isOpen: !this.state.isOpenMenu }
    this.setState({ isOpenMenu: state.isOpen })
  }

  render () {
    let GeneralRoutes = (
      <Switch>
        <Route exact path='/mochileros' component={GeneralMochilleros} />
        <Route exact path='/valledetenza' component={GeneralValledetenza} />
        <Route exact path='/paez' component={GeneralPaez} />
      </Switch>
    )

    let Redirects = (
      <Switch>
        <Redirect from='/mochileros' to='/home' />
        <Redirect from='/valledetenza' to='/home' />
        <Redirect from='/paez' to='/home' />
      </Switch>
    )

    return (
      <div style={{ height: '100%' }}>
        <Layout style={{ height: '100%' }} hasSider>
          <Menu
            location={this.props.location.pathname}
            isOpenMenu={this.state.isOpenMenu}
            onToggleMenu={this.onToggleMenu.bind(this)}
          />
          <Layout>
            <Header style={{ height: '56px', padding: '0', background: '#fff', lineHeight: '56px' }}>
              <Button
                icon={this.state.isOpenMenu ? 'menu-fold' : 'menu-unfold'}
                className='btn-border-less'
                onClick={() => this.onToggleMenu.bind(this)()}
              />
              <MediaQuery maxWidth={1279}><LogoSmall /></MediaQuery>
              <Notifications />
            </Header>
            <Content>
              <Switch>
                <Route exact path='/' component={Home} />
                <Route exact path='/home' component={Home} />

                <Route exact path='/valledetenza/pressure' component={PressureValledetenza} />
                <Route exact path='/valledetenza/temperature' component={TemperatureValledetenza} />
                <Route exact path='/valledetenza/flow' component={FlowValledetenza} />
                
                <Route exact path='/mochileros/pressure' component={PressureMochileros} />
                <Route exact path='/mochileros/temperature' component={TemperatureMochileros} />
                <Route exact path='/mochileros/flow' component={FlowMochileros} />

                <Route exact path='/paez/pressure' component={PressurePaez} />
                <Route exact path='/paez/volumen' component={VolumenPaez} />

                <Route exact path='/umbita/pressure' component={PressureUmbita}/>
                <Route exact path='/umbita/volumen' component={VolumenUmbita} />
                <Route exact path='/umbita/temperature' component={TemperatureUmbita} />

                <MediaQuery minWidth={1280}>
                  {(matches) => matches ? GeneralRoutes : Redirects}
                </MediaQuery>
              </Switch>
            </Content>
          </Layout>
        </Layout>
        <Cinnova />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js